/* eslint-disable react/prop-types */
import { Box, Button, Stack, styled, Typography } from '@mui/material';
import React from 'react';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import CopyToClipboard from 'react-copy-to-clipboard';
import useLocales from '../../hooks/useLocales';

const GDContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(3),
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  borderTop: `2px solid ${theme.palette.primary.main}`,
  fontSize: '15px',
}));

const GDDescription = styled(Typography)(({ theme }) => ({
  fontSize: 'inherit',
  fontWeight: 500,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  color: '#fff',
}));

const GDCreds = styled(Box)(({ theme }) => ({
  border: `1px solid #FFD700`,
  backgroundColor: '#232734',
  fontSize: 'inherit',
  color: 'inherit',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '5px',
  cursor: 'pointer',
  wordWrap: 'break-word',
  '& span': {
    color: theme.palette.primary.main,
  },
}));

const GDCopyButton = styled(Button)(() => ({
  textTransform: 'uppercase',
}));

const GDFooter = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: 'flex',
  flexWrap: 'wrap',
  gap: '10px',
  justifyContent: 'flex-end',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));

const GDDownloadButton = styled(LoadingButton)(({ theme }) => ({
  borderColor: '#25729a',
  background: 'linear-gradient(to bottom, #3093c7, #1c5a85)',
  color: 'inherit',
  fontSize: '16px',
  flex: '1 1 0',
  minWidth: '120px',
  [theme.breakpoints.down('sm')]: {
    flex: '0 0 48%',
  },
}));

const GDPlayButton = styled(LoadingButton)(({ theme }) => ({
  borderColor: '#001A1C',
  background: 'linear-gradient(to bottom, #fad643, #926c15)',
  color: 'inherit',
  fontSize: 'inherit',
  flex: '1 1 0',
  minWidth: '120px',
  [theme.breakpoints.down('sm')]: {
    flex: '0 0 48%',
    alignSelf: 'center',
  },
}));

const GameDownload = ({ data }) => {
  const { translate } = useLocales();
  const { enqueueSnackbar } = useSnackbar();

  const handleDownload = () => {
    window.open(data?.download_url, '_blank');
  };

  const handleDownloadIos = () => {
    window.open(data?.download_url_ios, '_blank');
  };

  const handlePlay = () => {
    let launchUrl = `lobbymegarelease://?account=${data?.login_username}&password=${data?.login_password}`;
    if (data?.code === 'ALIBABA') {
      launchUrl = `alibaba://alibaba?Account=${data?.login_username}&Password=${data?.login_password}`;
    }
    if (data?.code === 'GW99') {
      launchUrl = `lobbygw99://lobbygw99?account=${data?.login_username}&password=${data?.login_password}`;
    }

    window.open(launchUrl, '_blank');
  };

  return (
    <GDContainer>
      <GDDescription>{translate('please_download_x_to_play', { x: data?.code })}</GDDescription>
      <Stack>
        <CopyToClipboard text={data?.login_username} onCopy={() => enqueueSnackbar('Copied!')}>
          <GDCreds>
            <Box>
              {translate('username')} : <span>{data?.login_username}</span>
            </Box>
            <Box>
              <GDCopyButton variant="contained" size="small" color="error">
                {translate('copy')}
              </GDCopyButton>
            </Box>
          </GDCreds>
        </CopyToClipboard>
        <CopyToClipboard text={data?.login_password} onCopy={() => enqueueSnackbar('Copied!')}>
          <GDCreds>
            <Box>
              {translate('password')} : <span>{data?.login_password}</span>
            </Box>
            <Box>
              <GDCopyButton variant="contained" size="small" color="error">
                {translate('copy')}
              </GDCopyButton>
            </Box>
          </GDCreds>
        </CopyToClipboard>
      </Stack>

      <GDFooter>
        <GDDownloadButton onClick={handleDownload}>{translate('download')}</GDDownloadButton>
        {data?.download_url_ios ? (
          <GDDownloadButton onClick={handleDownloadIos}>{translate('download_ios')}</GDDownloadButton>
        ) : (
          ''
        )}
        {data?.code === 'MEGA888' || data?.code === 'ALIBABA' || data?.code === 'GW99' ? (
          <GDPlayButton onClick={handlePlay}>{translate('play_now')}</GDPlayButton>
        ) : (
          ''
        )}
      </GDFooter>
    </GDContainer>
  );
};

export default GameDownload;
